/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DepartementProjection } from './DepartementProjection';
import {
    DepartementProjectionFromJSON,
    DepartementProjectionFromJSONTyped,
    DepartementProjectionToJSON,
    DepartementProjectionToJSONTyped,
} from './DepartementProjection';
import type { EmployeeUserProjection } from './EmployeeUserProjection';
import {
    EmployeeUserProjectionFromJSON,
    EmployeeUserProjectionFromJSONTyped,
    EmployeeUserProjectionToJSON,
    EmployeeUserProjectionToJSONTyped,
} from './EmployeeUserProjection';

/**
 * 
 * @export
 * @interface EmployeeProjection
 */
export interface EmployeeProjection {
    /**
     * 
     * @type {string}
     * @memberof EmployeeProjection
     */
    jobTitle?: string;
    /**
     * 
     * @type {DepartementProjection}
     * @memberof EmployeeProjection
     */
    departmentId?: DepartementProjection | null;
    /**
     * 
     * @type {EmployeeUserProjection}
     * @memberof EmployeeProjection
     */
    parentId?: EmployeeUserProjection | null;
    /**
     * 
     * @type {Array<EmployeeUserProjection>}
     * @memberof EmployeeProjection
     */
    childIds?: Array<EmployeeUserProjection> | null;
    /**
     * 
     * @type {Array<EmployeeUserProjection>}
     * @memberof EmployeeProjection
     */
    subordinateIds?: Array<EmployeeUserProjection> | null;
}

/**
 * Check if a given object implements the EmployeeProjection interface.
 */
export function instanceOfEmployeeProjection(value: object): value is EmployeeProjection {
    return true;
}

export function EmployeeProjectionFromJSON(json: any): EmployeeProjection {
    return EmployeeProjectionFromJSONTyped(json, false);
}

export function EmployeeProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'jobTitle': json['job_title'] == null ? undefined : json['job_title'],
        'departmentId': json['department_id'] == null ? undefined : DepartementProjectionFromJSON(json['department_id']),
        'parentId': json['parent_id'] == null ? undefined : EmployeeUserProjectionFromJSON(json['parent_id']),
        'childIds': json['child_ids'] == null ? undefined : ((json['child_ids'] as Array<any>).map(EmployeeUserProjectionFromJSON)),
        'subordinateIds': json['subordinate_ids'] == null ? undefined : ((json['subordinate_ids'] as Array<any>).map(EmployeeUserProjectionFromJSON)),
    };
}

export function EmployeeProjectionToJSON(json: any): EmployeeProjection {
    return EmployeeProjectionToJSONTyped(json, false);
}

export function EmployeeProjectionToJSONTyped(value?: EmployeeProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'job_title': value['jobTitle'],
        'department_id': DepartementProjectionToJSON(value['departmentId']),
        'parent_id': EmployeeUserProjectionToJSON(value['parentId']),
        'child_ids': value['childIds'] == null ? undefined : ((value['childIds'] as Array<any>).map(EmployeeUserProjectionToJSON)),
        'subordinate_ids': value['subordinateIds'] == null ? undefined : ((value['subordinateIds'] as Array<any>).map(EmployeeUserProjectionToJSON)),
    };
}

